import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/free-mode";

import "./Gallery_Inner.css";
import { FaMapMarkerAlt, FaTimes } from "react-icons/fa";

import { GalleryById } from "../../../utils/apis/gallery/Gallery";
import { IDS } from "../../../utils/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const GalleryInner = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const swiperRef = useRef(null);
  const HtmlToReactParser = require("html-to-react").Parser;
  const htmlToReactParser = new HtmlToReactParser();

  const [images, setImages] = useState([]);
  const [gallery, setGallery] = useState({});

  const getGallery = async () => {
    const res = await GalleryById(id);
    if (res?.success) {
      setGallery(res?.data || {});
      setImages(res?.data || []);
    }
  };

  useEffect(() => {
    if (id) getGallery();
  }, [id]);

  const handleClose = () => {
    navigate("/gallery-showcase");
  };

  return (
    <div className="gallery-wrapper gallery-inner-page">
      <div className="gallery-main-wrapper container">
        <Swiper
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          spaceBetween={10}
          loop={true}
          thumbs={{
            swiper:
              thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
          }}
          modules={[Navigation, Thumbs]}
          className="gallery-main"
        >
          {images.map((img) => (
            <SwiperSlide key={img.id}>
              <div className="thumb_main_div">
                <img src={IDS?.IMG_URL + img.image} alt="main" />
              </div>
            </SwiperSlide>
          ))}

          <button className="close-btn" onClick={handleClose}>
            <FaTimes />
          </button>

          {/* <div className="gallery-overlay">
          <div className="location">
            <FaMapMarkerAlt />
            <span>{gallery?.name}</span>
          </div>
          <p>{htmlToReactParser.parse(gallery?.description)}</p>
        </div> */}
        </Swiper>
        <div className="custom-nav">
          <button
            className="custom-prev"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>

          <button
            className="custom-next"
            onClick={() => swiperRef.current?.slideNext()}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>
      <div className="gallery-aside container">
        <Swiper
          onSwiper={setThumbsSwiper}
          slidesPerView="auto"
          // centeredSlides={true}
          spaceBetween={10}
          freeMode={true}
          watchSlidesProgress={true}
          slideToClickedSlide={true}
          modules={[FreeMode, Thumbs]}
          className="gallery-thumbs"
          breakpoints={{
            0: {
              slidesPerView: 5,
              spaceBetween: 8,
            },
            480: {
              slidesPerView: 8,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 5,
              spaceBetween: 12,
            },
            1024: {
              slidesPerView: 8,
              spaceBetween: 15,
            },
          }}
        >
          {images.map((img) => (
            <SwiperSlide key={img.id}>
              <img src={IDS?.IMG_URL + img.image} alt="thumb" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default GalleryInner;
